var $window = $(window);
var breakPoint = 1024;

var resizeFlag = false;
var windowWidth = $window.width();
var windowHeight = $window.height();

//ローディング
import {loading} from "../include/module";
loading();

//ページTOP
import {pageTop} from "../include/module";
pageTop();

//ヘッダーの開閉
import {headerToggle} from "../include/module";
headerToggle();

//外部ページからのアンカー
import {externalAnchor} from "../include/module";
externalAnchor();

//ページ内リンクのアニメーション
import {anchorScroll} from "../include/module";
anchorScroll();

// preload
import {preload} from "../include/module";
preload();

// resizing
import {resizing} from "../include/module";
resizing();

// アニメーション
import {animationFire} from "../include/module";
animationFire();

// ページ下部のキャラランダム表示
import {bottomCharaRandom} from "../include/module";
bottomCharaRandom();



// WEBPACK FOOTER //
// script.js